module.exports = __webpack_public_path__ + "static/img/product1-4.0064dae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product1-4.jpg
// module id = quXw
// module chunks = 0